export default "__VITE_ASSET__6IHHz5X6__"